__turbopack_context__.v({
  "content": "Menu-module__cwgcIa__content",
  "item": "Menu-module__cwgcIa__item",
  "menuIn": "Menu-module__cwgcIa__menuIn",
  "menuOut": "Menu-module__cwgcIa__menuOut",
  "separator": "Menu-module__cwgcIa__separator",
  "subContent": "Menu-module__cwgcIa__subContent",
  "subTrigger": "Menu-module__cwgcIa__subTrigger",
});
